import React, { Component } from 'react';
import CustomModal from './CustomModal';

class RemoveConfigurationModal extends Component {
  render() {
    const { isShowing, onCancel, onRemove } = this.props;
    return (
      <CustomModal
        isShowing={isShowing}
        title="Remove Configuration"
        baseStyle="danger"
        description={
          <p>
            All outlets assigned to this custom configuration will be
            automatically reassigned to <b>Default Configuration</b>. Do you
            want to remove this configuration?
          </p>
        }
        buttonProceedText="Remove"
        onCancel={onCancel}
        onProceed={onRemove}
      />
    );
  }
}

RemoveConfigurationModal.defaultProps = {
  isShowing: false,
  onCancel: () => {},
  onRemove: () => {},
};

export default RemoveConfigurationModal;
